/* IMENHOF BLOOM -- cart-page.js
   Live winkelwagenpagina: optimistisch herberekenen van regelprijs,
   subtotaal en bezorgbalk, met verzoening tegen de echte cart. Owns de
   +/- stappers (capture + stopImmediatePropagation) zodat de globale
   stepper in theme.js niet dubbel telt; vangt ook getypte aantallen en
   de Verwijderen-link op. Hergebruikt window.ImhUndo voor de undo-strook.
   Extern geladen (theme.liquid, alleen op template 'cart') zodat het
   altijd draait -- ook in de theme-editor preview. */
(function () {
  'use strict';

  function init() {
    var form = document.querySelector('.cartpage');
    if (!form || form.dataset.imhCartReady) return;
    form.dataset.imhCartReady = '1';

    var DEBOUNCE = 350;
    var inflight = 0;
    var timers = {};
    var queued = {};
    var noteTimer = null;

    function money(cents) {
      if (window.Shopify && Shopify.formatMoney && window.themeMoneyFormat) {
        return Shopify.formatMoney(cents, window.themeMoneyFormat);
      }
      return '\u20ac' + (cents / 100).toFixed(2).replace('.', ',');
    }

    var progEl0 = form.querySelector('.cart-progress');
    var threshold = progEl0 ? (parseInt(progEl0.dataset.threshold, 10) || 0) : 0;
    var localThreshold = progEl0 ? (parseInt(progEl0.dataset.localThreshold, 10) || 0) : 0;
    var localRadius = progEl0 ? (parseInt(progEl0.dataset.localRadius, 10) || 10) : 10;

    var totalEl = form.querySelector('.cart-foot__total');
    var subtotal = totalEl ? (parseInt(totalEl.dataset.cents, 10) || 0) : 0;

    var updateBtn = form.querySelector('[name="update"]');
    if (updateBtn) updateBtn.style.display = 'none';

    function pendingUndo() { return form.querySelectorAll('[data-undo-pending]').length; }

    function paintProgress() {
      var prog = form.querySelector('.cart-progress');
      if (!prog || threshold <= 0) return;
      var localPending = localThreshold > 0 && subtotal < localThreshold;
      var target = localPending ? localThreshold : threshold;
      var pct = Math.min(100, (subtotal / target) * 100);
      var remain = threshold - subtotal;
      var localRemain = localThreshold - subtotal;
      var fill = prog.querySelector('.cart-progress__fill');
      if (fill) fill.style.width = pct + '%';
      var p = prog.querySelector('p');
      if (p) {
        if (localPending) {
        p.textContent = 'Nog ' + money(localRemain) + ' tot lokale bezorging binnen ' + localRadius + ' km \ud83c\udf3f';
        } else if (remain > 0) {
          p.textContent = 'Lokale bezorging binnen ' + localRadius + ' km is beschikbaar. Nog ' + money(remain) + ' tot bezorging buiten ' + localRadius + ' km \ud83c\udf3f';
        } else {
          p.textContent = 'Je komt in aanmerking voor bezorging aan huis \ud83c\udf3f';
        }
      }
    }

    function paintTotals() {
      if (totalEl) { totalEl.textContent = money(subtotal); totalEl.dataset.cents = subtotal; }
      paintProgress();
    }

    function setCount(n) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = n; el.hidden = n === 0;
      });
    }

    function recomputeOptimistic() {
      var sum = 0;
      form.querySelectorAll('.cart-line').forEach(function (l) {
        if (l.hasAttribute('data-undo-pending')) return;
        var u = parseInt(l.dataset.unit, 10) || 0;
        var inp = l.querySelector('input[name="updates[]"]');
        var q = inp ? (parseInt(inp.value, 10) || 0) : 0;
        var price = l.querySelector('.cart-line__price');
        if (price) price.textContent = money(u * q);
        sum += u * q;
      });
      subtotal = sum < 0 ? 0 : sum;
      paintTotals();
    }

    function reconcile(cart) {
      if (cart.item_count === 0 && pendingUndo() === 0) { window.location.reload(); return; }
      subtotal = cart.total_price;
      setCount(cart.item_count);
      form.querySelectorAll('.cart-line').forEach(function (line) {
        if (line.hasAttribute('data-undo-pending')) return;
        var item = cart.items.filter(function (it) { return it.key === line.dataset.key; })[0];
        if (!item) { line.remove(); return; }
        var input = line.querySelector('input[name="updates[]"]');
        if (input && document.activeElement !== input) input.value = item.quantity;
        line.dataset.unit = item.final_price;
        var price = line.querySelector('.cart-line__price');
        if (price) price.textContent = money(item.final_line_price);
        line.style.opacity = '';
      });
      paintTotals();
    }

    function commit(key, qty, line) {
      inflight++;
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
      }).then(function (r) { return r.json(); }).then(function (cart) {
        reconcile(cart); return cart;
      }).catch(function () {
        if (line) line.style.opacity = '';
      }).then(function (c) { inflight--; return c; }, function (e) { inflight--; throw e; });
    }

    function scheduleChange(line, qty) {
      var key = line.dataset.key;
      queued[key] = qty;
      clearTimeout(timers[key]);
      line.style.opacity = '.6';
      timers[key] = setTimeout(function () {
        delete queued[key];
        commit(key, qty, line);
      }, DEBOUNCE);
    }

    function flushQueued() {
      var ps = [];
      Object.keys(queued).forEach(function (key) {
        clearTimeout(timers[key]);
        var qty = queued[key]; delete queued[key];
        ps.push(commit(key, qty, null));
      });
      return Promise.all(ps);
    }

    function whenIdle(maxMs) {
      return new Promise(function (resolve) {
        var t0 = Date.now();
        (function poll() {
          if (inflight <= 0 || Date.now() - t0 > maxMs) return resolve();
          setTimeout(poll, 60);
        })();
      });
    }

    function flushNote() {
      var note = form.querySelector('textarea[name="note"]');
      if (!note) return Promise.resolve();
      clearTimeout(noteTimer);
      inflight++;
      return fetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: note.value })
      }).catch(function () {}).then(function () { inflight--; });
    }

    function removeLine(line) {
      var key = line.dataset.key;
      /* Annuleer een nog lopende aantal-wijziging voor deze regel, zodat die
         niet alsnog qty 1 terugzet na het verwijderen. */
      clearTimeout(timers[key]);
      delete queued[key];
      /* Optimistisch: regel meteen als pending markeren en het subtotaal +
         de bezorgbalk direct herrekenen, zodat het Overzicht niet achterloopt
         terwijl de verzoek-rondes nog lopen. */
      line.setAttribute('data-undo-pending', '1');
      recomputeOptimistic();
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var item = cart.items.filter(function (it) { return it.key === key; })[0];
        var snap = item ? { id: item.id, quantity: item.quantity, title: item.product_title || item.title } : null;
        commit(key, 0, null).then(function () {
          if (!snap || !window.ImhUndo) { line.remove(); return; }
          window.ImhUndo.mountRow(line, {
            title: snap.title,
            onUndo: function (restore) {
              restore();
              inflight++;
              fetch('/cart/add.js', {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: snap.id, quantity: snap.quantity })
              }).then(function () { return fetch('/cart.js'); })
                .then(function (r) { return r.json(); }).then(function (cart) {
                  var it = cart.items.filter(function (i) { return String(i.variant_id) === String(snap.id); })[0];
                  if (it) line.dataset.key = it.key;
                  reconcile(cart);
                }).catch(function () { window.location.reload(); })
                .then(function () { inflight--; }, function () { inflight--; });
            },
            onExpire: function (slot) {
              slot.remove();
              if (!form.querySelector('.cart-line, .cart-undo-row')) window.location.reload();
            }
          });
        });
      }).catch(function () { commit(key, 0, line); });
    }

    /* +/- in capture-fase: meteen optimistisch herrekenen en theme.js stoppen. */
    form.addEventListener('click', function (e) {
      var btn = e.target.closest('.qty button');
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var line = btn.closest('.cart-line');
      if (!line || line.hasAttribute('data-undo-pending')) return;
      var input = line.querySelector('input[name="updates[]"]');
      var cur = parseInt(input.value, 10) || 0;
      var next = cur + (btn.dataset.dir === 'up' ? 1 : -1);
      if (next < 0) next = 0;
      input.value = next;
      if (next === 0) { removeLine(line); return; }
      recomputeOptimistic();
      scheduleChange(line, next);
    }, true);

    /* Getypt aantal, of een change die theme.js eventueel toch dispatcht. */
    form.addEventListener('change', function (e) {
      var input = e.target.closest('input[name="updates[]"]');
      if (!input) return;
      var line = input.closest('.cart-line');
      if (!line || line.hasAttribute('data-undo-pending')) return;
      var qty = parseInt(input.value, 10);
      if (isNaN(qty) || qty < 0) { qty = 0; input.value = 0; }
      if (qty === 0) { removeLine(line); return; }
      recomputeOptimistic();
      scheduleChange(line, qty);
    });

    /* Verwijderen-link. */
    form.addEventListener('click', function (e) {
      var rm = e.target.closest('.cart-line__remove');
      if (!rm) return;
      e.preventDefault();
      var line = rm.closest('.cart-line');
      if (line && !line.hasAttribute('data-undo-pending')) removeLine(line);
    });

    /* Cross-sell 'Vergeet je potgrond niet': toevoegen via /cart/add.js en
       daarna herladen, zodat de nieuwe regel verschijnt en het blok verdwijnt.
       Plain buttons -- geen geneste <form> in het cart-formulier. Variant-ID
       als GETAL meesturen: /cart/add.js geeft 400 op een string-ID via JSON.
       Bij een echte fout: knop resetten en foutregel tonen (geen valse 'ok'). */
    form.addEventListener('click', function (e) {
      var add = e.target.closest('[data-pg-add]');
      if (!add) return;
      e.preventDefault();
      if (add.dataset.busy) return;
      var vid = parseInt(add.getAttribute('data-variant-id'), 10);
      var errEl = form.querySelector('[data-pg-err]');
      if (errEl) errEl.hidden = true;
      if (!vid) { if (errEl) errEl.hidden = false; return; }
      add.dataset.busy = '1';
      add.classList.add('is-loading');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: vid, quantity: 1 })
      }).then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) { throw new Error((data && data.description) || 'add failed'); }
          return data;
        });
      }).then(function () {
        window.location.reload();
      }).catch(function () {
        delete add.dataset.busy;
        add.classList.remove('is-loading');
        if (errEl) errEl.hidden = false;
      });
    });

    /* Notitie automatisch opslaan. */
    var note = form.querySelector('textarea[name="note"]');
    if (note) {
      note.addEventListener('input', function () {
        clearTimeout(noteTimer);
        noteTimer = setTimeout(function () {
          fetch('/cart/update.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: note.value })
          }).catch(function () {});
        }, 600);
      });
    }

    /* Afrekenen: eerst alle openstaande schrijfacties afronden (aantallen,
       notitie), dan rechtstreeks naar de checkout navigeren -- dezelfde URL
       die de drawer gebruikt. Bewust GEEN form.requestSubmit meer: dat hangt af
       van de koppeling knop<->formulier. De klik-handler zit direct op de knop,
       dus navigeren werkt altijd. De knop blijft type=submit als no-JS vangnet. */
    var checkoutBtn = form.querySelector('[name="checkout"]');
    if (checkoutBtn) {
      var checkoutUrl = checkoutBtn.getAttribute('data-checkout-url') || '/checkout';
      checkoutBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (checkoutBtn.dataset.busy) return;
        checkoutBtn.dataset.busy = '1';
        checkoutBtn.classList.add('is-loading');
        checkoutBtn.textContent = 'Even geduld\u2026';
        function go() { window.location.href = checkoutUrl; }
        Promise.resolve()
          .then(flushQueued)
          .then(flushNote)
          .then(function () { return whenIdle(4000); })
          .then(go, go);
      });
      /* Terug uit de bfcache (back-knop): reset de knop, anders blijft hij
         op 'Even geduld' hangen en lijkt hij niet te reageren. */
      window.addEventListener('pageshow', function (e) {
        if (e.persisted) {
          delete checkoutBtn.dataset.busy;
          checkoutBtn.classList.remove('is-loading');
          checkoutBtn.textContent = 'Afrekenen';
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
